export default __webpack_public_path__ + "defImage.c28944fa.png";